module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "welcome-page"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "username"
  }, [_vm._v("Hey, " + _vm._s(this.username) + "!")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('button', {
    staticClass: "invite-button",
    on: {
      "click": function($event) {
        _vm.copyLink()
      }
    }
  }, [_vm._v("Invite your friends")]), _vm._v(" "), _c('router-link', {
    staticClass: "home-link",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("\n      Back home\n    ")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "yousound"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/images/nav_logo_primary.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/welcome-avatar.svg",
      "alt": "avatar"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message"
  }, [_vm._v("\n      YouSound will be launching soon. "), _c('br'), _vm._v("\n      In the meantime, you can invite friends to join the fun.\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60175eb9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/welcomePage/index.vue
// module id = 1742
// module chunks = 180